import React, { Component } from "react";
import { connect } from "react-redux";
import TextFieldGroup from "../../commons/TextFieldGroup";
import axios from "axios";
import isEmpty from "../../validation/is-empty";
import MessageBoxInfo from "../../commons/MessageBoxInfo";
import Searchbar from "../../commons/Searchbar";

import { Layout, Breadcrumb, Form, Table, Icon, message, Row, Col } from "antd";

import { formItemLayout, tailFormItemLayout } from "./../../utils/Layouts";
import RadioGroupFieldGroup from "../../commons/RadioGroupFieldGroup";
import { markup_options } from "../../utils/Options";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import { onChange, onDeleteItem } from "../../utils/form_utilities";
import {
  _onWarehouseSearch,
  onBranchSearch,
  onOtherPaymentSearch,
  onOtherPaymentSearchLegacy,
} from "../../utils/utilities";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import { addKeysToArray } from "../../utils/utilities";
import { EditOutlined } from "@ant-design/icons";
const { Content } = Layout;

const collection_name = "tables";

const form_data = {
  [collection_name]: [],
  _id: "",
  name: "",
  prefix: "",
  markup_option: null,
  markup: null,
  variations: [],
  variation_markup_option: null,
  variation_markup: null,
  bg_color: "",
  errors: {},
};

class TieupForm extends Component {
  state = {
    title: "Tieup Form",
    url: "/api/tieups/",
    search_keyword: "",
    ...form_data,

    options: {
      other_payments: [],
    },
  };

  onChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    this.setState({ [e.target.name]: value });
  };

  onSubmit = (e) => {
    if (e) e.preventDefault();

    const form_data = {
      ...this.state,
      user: this.props.auth.user,
    };

    if (isEmpty(this.state._id)) {
      axios
        .put(this.state.url, form_data)
        .then(({ data }) => {
          message.success("Transaction Saved");
          this.setState({
            ...data,
            errors: {},
            message: "Transaction Saved",
          });
        })
        .catch((err) => {
          message.error("You have an invalid input");
          this.setState({ errors: err.response.data });
        });
    } else {
      axios
        .post(this.state.url + this.state._id, form_data)
        .then(({ data }) => {
          message.success("Transaction Updated");
          this.setState({
            ...data,
            errors: {},
            message: "Transaction Updated",
          });
        })
        .catch((err) => this.setState({ errors: err.response.data }));
    }
  };

  onSearch = (value, e) => {
    e.preventDefault();

    axios
      .get(this.state.url + "?s=" + this.state.search_keyword)
      .then((response) =>
        this.setState({
          [collection_name]: response.data,
          message: isEmpty(response.data) ? "No rows found" : "",
        })
      )
      .catch((err) => console.log(err));
  };

  addNew = () => {
    this.setState({
      ...form_data,
      errors: {},
      message: "",
    });
  };

  edit = (record) => {
    axios
      .get(this.state.url + record._id)
      .then((response) => {
        const record = response.data;
        this.setState((prevState) => {
          return {
            ...form_data,
            [collection_name]: [],
            ...record,
            errors: {},
          };
        });
      })
      .catch((err) => console.log(err));
  };

  onDelete = () => {
    axios
      .delete(this.state.url + this.state._id)
      .then((response) => {
        message.success("Transaction Deleted");
        this.setState({
          ...form_data,
          message: "Transaction Deleted",
        });
      })
      .catch((err) => {
        message.error(err.response.data.message);
      });
  };

  onHide = () => {
    this.setState({ message: "" });
  };

  render() {
    const records_column = [
      {
        title: "Tieup",
        dataIndex: "name",
      },
      {
        title: "Markup Option",
        dataIndex: "markup_option",
      },
      {
        title: "Markup",
        dataIndex: "markup",
      },
      {
        title: "Variation Markup Option",
        dataIndex: "variation_markup_option",
      },
      {
        title: "Variation Markup",
        dataIndex: "variation_markup",
      },
      {
        title: "",
        key: "action",
        width: 10,
        render: (text, record) => (
          <span>
            <EditOutlined onClick={() => this.edit(record)} />
          </span>
        ),
      },
    ];

    const { errors } = this.state;

    return (
      <Content style={{ padding: "0 50px" }}>
        <div className="columns is-marginless">
          <div className="column">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>Tieups</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="column">
            <Searchbar
              name="search_keyword"
              onSearch={this.onSearch}
              onChange={this.onChange}
              value={this.state.search_keyword}
              onNew={this.addNew}
            />
          </div>
        </div>

        <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
          <span className="is-size-5">{this.state.title}</span> <hr />
          <MessageBoxInfo message={this.state.message} onHide={this.onHide} />
          {isEmpty(this.state[collection_name]) ? (
            <Form onFinish={() => this.onSubmit()}>
              <TextFieldGroup
                label="Name"
                name="name"
                value={this.state.name}
                error={errors.name}
                formItemLayout={formItemLayout}
                onChange={this.onChange}
              />
              <TextFieldGroup
                label="Prefix"
                name="prefix"
                value={this.state.prefix}
                error={errors.prefix}
                formItemLayout={formItemLayout}
                onChange={this.onChange}
              />
              <RadioGroupFieldGroup
                label="Markup Option"
                name="markup_option"
                onChange={this.onChange}
                error={errors.markup_option}
                value={this.state.markup_option}
                options={markup_options}
                formItemLayout={formItemLayout}
              />
              <TextFieldGroup
                label="Markup"
                name="markup"
                value={this.state.markup}
                error={errors.markup}
                formItemLayout={formItemLayout}
                onChange={this.onChange}
              />
              <TextFieldGroup
                label="BG Color"
                name="bg_color"
                value={this.state.bg_color}
                error={errors.bg_color}
                formItemLayout={formItemLayout}
                onChange={this.onChange}
              />
              <SelectTagFieldGroup
                label="Variations"
                value={this.state.variations}
                onChange={(value) => {
                  onChange({
                    key: "variations",
                    value,
                    setState: (e) => {
                      this.setState(e);
                    },
                  });
                }}
                formItemLayout={formItemLayout}
              />
              ,
              <RadioGroupFieldGroup
                label="Variation Markup Option"
                name="variation_markup_option"
                onChange={this.onChange}
                error={errors.variation_markup_option}
                value={this.state.variation_markup_option}
                options={markup_options}
                formItemLayout={formItemLayout}
              />
              <TextFieldGroup
                label="Variation Markup"
                name="variation_markup"
                value={this.state.variation_markup}
                error={errors.variation_markup}
                formItemLayout={formItemLayout}
                onChange={this.onChange}
              />
              <SelectFieldGroup
                label="Payment Method"
                value={null}
                onSearch={(value) =>
                  onOtherPaymentSearchLegacy({
                    value,
                    setOptions: (other_payments) => {
                      this.setState({
                        options: {
                          ...this.state.options,
                          other_payments,
                        },
                      });
                    },
                  })
                }
                onChange={(index) => {
                  const payment_method =
                    this.state.options.other_payments[index];

                  this.setState((prevState) => ({
                    ...prevState,
                    payment_methods: [
                      ...(prevState.payment_methods || []),
                      payment_method,
                    ],
                  }));
                }}
                error={errors.payment_method}
                formItemLayout={formItemLayout}
                data={this.state.options.other_payments || []}
                column="name"
              />
              <Row>
                <Col offset={4} span={20}>
                  <Table
                    dataSource={addKeysToArray(
                      this.state.payment_methods || []
                    )}
                    columns={[
                      {
                        title: "Name",
                        dataIndex: ["name"],
                      },
                      {
                        title: "",
                        key: "action",
                        width: 100,
                        render: (text, record, index) => (
                          <span>
                            {isEmpty(this.state.deleted) && (
                              <span
                                className="button is-danger is-outlined is-small"
                                onClick={() => {
                                  onDeleteItem({
                                    field: "payment_methods",
                                    index,
                                    setState: (func) => {
                                      this.setState(func);
                                    },
                                  });
                                }}
                              >
                                <span>Delete</span>
                                <span>
                                  <i className="fas fa-times"></i>
                                </span>
                              </span>
                            )}
                          </span>
                        ),
                      },
                    ]}
                    pagination={false}
                  />
                </Col>
              </Row>
              <SelectFieldGroup
                label="Branch"
                value={null}
                onSearch={(value) => {
                  _onWarehouseSearch({
                    value,
                    setOptions: (branches) => {
                      this.setState({
                        options: {
                          ...this.state.options,
                          branches,
                        },
                      });
                    },
                  });
                }}
                onChange={(index) => {
                  const branch = this.state.options.branches?.[index] || null;

                  this.setState((prevState) => ({
                    ...prevState,
                    tieup_codes: [
                      ...(prevState.tieup_codes || []),
                      { branch, tieup_code: "" },
                    ],
                  }));
                }}
                formItemLayout={formItemLayout}
                data={this.state.options.branches}
                column="name"
              />
              <Row>
                <Col offset={4} span={20}>
                  <Table
                    dataSource={addKeysToArray(this.state.tieup_codes || [])}
                    columns={[
                      {
                        title: "Branch",
                        dataIndex: ["branch", "name"],
                      },
                      {
                        title: "Tieup Code",
                        dataIndex: ["tieup_code"],
                        render: (tieup_code, record, index) => {
                          return (
                            <input
                              type="text"
                              className="gray-border"
                              name="tieup_code"
                              value={tieup_code}
                              onChange={(e) => {
                                const target = e.target;

                                this.setState((prevState) => {
                                  const tieup_codes = [
                                    ...(prevState.tieup_codes || []),
                                  ];

                                  tieup_codes[index][target.name] =
                                    target.value;
                                  return {
                                    ...prevState,
                                    tieup_codes,
                                  };
                                });
                              }}
                            />
                          );
                        },
                      },
                      {
                        title: "",
                        key: "action",
                        width: 100,
                        render: (text, record, index) => (
                          <span>
                            {isEmpty(this.state.deleted) && (
                              <span
                                className="button is-danger is-outlined is-small"
                                onClick={() => {
                                  onDeleteItem({
                                    field: "tieup_codes",
                                    index,
                                    setState: (func) => {
                                      this.setState(func);
                                    },
                                  });
                                }}
                              >
                                <span>Delete</span>
                                <span>
                                  <i className="fas fa-times"></i>
                                </span>
                              </span>
                            )}
                          </span>
                        ),
                      },
                    ]}
                    pagination={false}
                  />
                </Col>
              </Row>
              <Form.Item className="m-t-1" {...tailFormItemLayout}>
                <div className="field is-grouped">
                  <div className="control">
                    <button className="button is-small is-primary">Save</button>
                  </div>
                  {!isEmpty(this.state._id) ? (
                    <span
                      className="button is-danger is-outlined is-small"
                      onClick={this.onDelete}
                    >
                      <span>Delete</span>
                      <span className="icon is-small">
                        <i className="fas fa-times" />
                      </span>
                    </span>
                  ) : null}
                </div>
              </Form.Item>
            </Form>
          ) : (
            <Table
              dataSource={this.state[collection_name]}
              columns={records_column}
              rowKey={(record) => record._id}
            />
          )}
        </div>
      </Content>
    );
  }
}

const mapToState = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapToState)(TieupForm);
